import {
  getAvailableMetrics as coreGetAvailableMetrics,
  type EntityType,
} from '@revelio/core';

import { FilterId, type PrimaryFilterId } from '../../../filters/types/filters';
import type { ChartType } from '../../PageConfigProvider/types/chart';

export const PRIMARY_FILTER_TO_ENTITY_TYPE: Record<
  PrimaryFilterId,
  EntityType
> = {
  [FilterId.COMPANY]: 'company',
  [FilterId.GEOGRAPHY]: 'geography',
  [FilterId.ROLE]: 'role',
};

export const getAvailableMetrics = ({
  primaryFilterId,
  chartType,
}: {
  primaryFilterId?: PrimaryFilterId;
  chartType?: ChartType;
}) => {
  if (!primaryFilterId) return [];
  const entityType = PRIMARY_FILTER_TO_ENTITY_TYPE[primaryFilterId];
  if (!entityType) return [];
  return coreGetAvailableMetrics({ entityType, chartType });
};
